// extracted by mini-css-extract-plugin
module.exports = {"b2bCooperationSection":"_2yR6d7TxF8k7x5_76gSx7e","b2bCooperationSection__header":"H88NT1h51PmRDH2XO8l_0","b2bCooperationSection__block":"_35ZzldjaVaqwb0HwIjxjvD"};